module.exports = __webpack_public_path__ + "static/media/Group 29060.35b9a5eb.svg";